"use client";
export { ServerSideOnboardingPackagesDetails as OnboardingPackagesDetails } from "@stadium/shared/src/components/onboarding-packages/details";
export { default as PricingTableHeader } from "@stadium/shared/src/components/onboarding-packages/details/pricing-table-header";
